import { useGoogleAnalytics } from "@/hooks/useGoogleAnalytics";
import { useCookieConsent } from "@/hooks/useCookieConsent";

const GATracker = () => {
  const { hasConsented } = useCookieConsent();
  
  // Alleen GA laden als consent is gegeven
  useGoogleAnalytics(hasConsented === true);
  
  return null;
};

export default GATracker;
